var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contenido',{staticClass:"pt-1"},[_c('portal',{attrs:{"to":"toolbar-secundaria-derecha"}}),_c('portal',{attrs:{"to":"toolbar-secundaria-titulo"}}),_c('listado',{attrs:{"Controlador":_vm.Controlador}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }